
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.208 6.252l.76-.689 1.136 1.034 1.136-1.029.76.684-1.14 1.03L11 8.31 10.24 9 9.104 7.966 7.97 9l-.76-.69 1.14-1.028-1.135-1.03M5.355 0c2.946 0 5.356 1.738 5.356 3.883 0 .282-.043.554-.118.816a3.586 3.586 0 00-1.018-.3c.043-.166.065-.34.065-.516C9.64 2.277 7.722.971 5.355.971S1.071 2.277 1.071 3.883c0 1.607 1.917 2.913 4.284 2.913l.584-.024-.048.51.043.46-.579.025a7.522 7.522 0 01-1.89-.243A6.27 6.27 0 010 8.738c1.248-1.131 1.473-1.893 1.473-2.185C.568 5.908.027 4.927 0 3.883 0 1.738 2.41 0 5.355 0z","fill":"#D70505"}})])
          )
        }
      }
    